import { Component, OnInit, ChangeDetectorRef, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { Layout } from '../../models/layout';
import { Router } from '@angular/router';
import { ListForm } from '../../../../base/controlers/list-form';
import { LayoutService } from '../../services/layout.service';
import { PagedListForm } from '../../../../base/controlers/paged-list-form';
import { fromEvent } from 'rxjs';
import { filter, debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';

@Component({
  selector: 'app-layout-list',
  templateUrl: './layout-list.component.html',
  styleUrls: ['./layout-list.component.css']
})
export class LayoutListComponent extends PagedListForm<Layout> implements OnInit, AfterViewInit {

  public displayedColumns = ['actions','code','name', 'price'];
  @ViewChild('search',{static:true}) search: ElementRef;
  constructor(
    protected layoutService: LayoutService,
    protected router:Router
  ) {
    super(layoutService,'/plasard-measurement/layout',router,null,'code',true);
   }
  ngOnInit() {
    super.ngOnInit();
  }
  ngAfterViewInit() {
    // server-side search
    fromEvent(this.search.nativeElement,'keyup')
        .pipe(
            filter(Boolean),
            debounceTime(300),
            distinctUntilChanged(),
            tap((_) => {
              const filter = this.search.nativeElement.value.trim();
              let query = null;
              if(filter){
                query = `contains(code, '${filter}') or contains(name, '${filter}')`;
              }
              this.onFilter(query);
            })
        )
        .subscribe();
    }  
}
